import { defineMessages } from "react-intl";

const messages: {[prop: string]: { id: string }}  = defineMessages({
    email: {
        id: "account.email",
    },
    username: {
        id: "account.username",
    },
    last_name: {
        id: "account.lastName",
    },
    first_name: {
        id: "account.firstName",
    },
    birthyear: {
        id: "account.birthyear",
    },
    work_since: {
        id: "account.workSince",
    },
    gender: {
        id: "account.gender",
    },
    language: {
        id: "account.language",
    },
    motherTongue: {
        id: "account.motherTongue",
    },
    facebookRemove: {
        id: "account.facebook.remove",
    },
    facebookConnected: {
        id: "account.facebook.connected",
    },
    facebookConnect: {
        id: "account.facebook.connect",
    },
    facebookConnectingInProgress: {
        id: "account.facebook.inProgress",
    },
    googleRemove: {
        id: "account.google.remove",
    },
    googleConnected: {
        id: "account.google.connected",
    },
    googleConnectingInProgress: {
        id: "account.google.inProgress",
    },
    googleConnect: {
        id: "account.google.connect",
    },
    usernameTooltip: {
        id: "account.usernameTooltip",
    },
    modifySomething: {
        id: "account.modal.changeSomething",
    },
    password: {
        id: "account.password",
    },
    createPassword: {
        id: "account.password.create",
    },
    deleteAccount: {
        id: "account.deleteAccount.button",
    },
    deleteAccountCreatePassword: {
        id: "account.deleteAccount.createPassword",
    },
    facebookConnectionError: {
        id: "facebook.connectionError",
    },
    facebookConnectionErrorMessage: {
        id: "facebook.connectionError.message",
    },
    facebookAlreadyConnected: {
        id: "facebook.alreadyConnected",
    },
    googleConnectionError: {
        id: "facebook.connectionError",
    },
    googleConnectionErrorMessage: {
        id: "google.connectionError.message",
    },
    googleAlreadyConnected: {
        id: "google.alreadyConnected",
    },
    close: {
        id: "general.close",
    },
    account: {
        id: "menu.account",
    },
    profilePicture: {
        id: "account.profilePicture",
    },
    modify: {
        id: "general.modify",
    },
    uploadPicture: {
        id: "account.uploadPicture",
    },
    cancel: {
        id: "general.cancel",
    },
    verified: {
        id: "account.email.verified",
    },
    notVerified: {
        id: "account.email.notVerified",
    },
    notGiven: {
        id: "account.email.notGiven",
    },
    emailToBeVerified: {
        id: "account.email.toBoVerified",
    },
    displayName: {
        id: "account.displayName",
    },
    resendVerification: {
        id: "account.resendVerification",
    },
    school_types: {
        id: "account.school_types",
    },
    save: {
        id: "changeDescription.submit",
    },
    oldPassword: {
        id: "account.oldPassword",
    },
    newPassword: {
        id: "account.newPassword",
    },
    newPasswordAgain: {
        id: "account.newPasswordAgain",
    },
    deleteAccountTitle: {
        id: "account.deleteAccount.title",
    },
    deleteAccountButton: {
        id: "account.deleteAccount.button",
    },
    deleteAccountConfirm: {
        id: "account.deleteAccount.confirm",
    },    
});

export default messages;
